// extracted by mini-css-extract-plugin
module.exports = {"select-custom":"CustomInput_select-custom__1gLl0","dropdown-custom":"CustomInput_dropdown-custom__FUtgU","check-custom":"CustomInput_check-custom__2lBcb"};